export default "__VITE_ASSET__yeLQjbf3__"